export const GoFrequencyResultMessages = {
    atLeastOneFrequencyResultMustBeSelected:
        'Please select at least one frequency line before proceeding.',
} as const;
